
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const LuxembourgInsuranceSection = () => {
  return (
    <section className="relative overflow-hidden py-24">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video 
          className="w-full h-full object-cover"
          autoPlay 
          loop 
          muted 
          playsInline
        >
          <source src="https://www.rhetores.fr/wp-content/uploads/2024/10/shutterstock1088716567online-video-cutter.com_.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
        {/* Overlay to ensure text readability */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      {/* Content */}
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h2 className="section-title text-white mb-8 animate-fade-in">
            L'Assurance Vie Luxembourgeoise
          </h2>
          
          <div className="prose prose-lg prose-invert mb-10 mx-auto">
            <p className="text-xl text-white/90 mb-6">
              Découvrez les avantages exceptionnels de l'assurance vie luxembourgeoise, 
              un outil privilégié pour la gestion et la transmission de votre patrimoine.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 my-12">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <h3 className="text-xl font-serif mb-4 text-patrimoine-gold">Sécurité Maximale</h3>
                <p className="text-white/80">
                  Bénéficiez du "Triangle de Sécurité" luxembourgeois offrant une protection 
                  inégalée pour vos actifs financiers.
                </p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <h3 className="text-xl font-serif mb-4 text-patrimoine-gold">Flexibilité d'Investissement</h3>
                <p className="text-white/80">
                  Accédez à une gamme étendue d'actifs éligibles et de stratégies d'investissement 
                  personnalisées pour optimiser votre rendement.
                </p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <h3 className="text-xl font-serif mb-4 text-patrimoine-gold">Avantages Fiscaux</h3>
                <p className="text-white/80">
                  Optimisez la fiscalité de votre épargne grâce aux spécificités du cadre 
                  luxembourgeois tout en respectant les réglementations françaises.
                </p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <h3 className="text-xl font-serif mb-4 text-patrimoine-gold">Transmission Optimisée</h3>
                <p className="text-white/80">
                  Planifiez efficacement la transmission de votre patrimoine grâce 
                  aux clauses bénéficiaires sur mesure.
                </p>
              </div>
            </div>
          </div>
          
          <Link to="/bilan-patrimonial">
            <Button className="cta-button text-lg font-medium group">
              Découvrir nos solutions
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LuxembourgInsuranceSection;
